import React from "react";
import { Link } from "react-scroll";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import tondela from "images/tondela.jpeg";
import Header, { LogoLink, NavLinks, NavLink as NavLinkBase } from "../headers/light.js";

const StyledHeader = styled(Header)`
  ${tw`justify-between`}
  ${LogoLink} {
    ${tw`mr-8 pb-0`}
  }
`;
const NavLink = tw(NavLinkBase)`
  sm:text-sm sm:mx-6
`;
const NavLinkScroll = styled(Link)`
  ${tw`
	text-lg my-2 lg:text-sm lg:mx-6 lg:my-0 font-semibold tracking-wide transition duration-300 pb-1 border-b-2 border-transparent 
  hover:border-primary-500 hocus:text-primary-500 sm:text-sm sm:mx-6 cursor-pointer
`}
`;
const LinkPointer = styled(Link)`${tw`cursor-pointer`}`;

const Container = tw.div`relative -mx-8 -mt-8`;
const TwoColumn = tw.div`flex flex-col lg:flex-row bg-gray-100`;
const LeftColumn = tw.div`ml-8 mr-8 xl:pl-10 py-8`;
const RightColumn = styled.div`
  background-image: url("${tondela}");
  ${tw`bg-green-500 bg-cover bg-center xl:ml-24 h-96 lg:h-auto lg:w-1/2 lg:flex-1`}
`;

const Content = tw.div`mt-24 lg:mt-24 lg:mb-24 flex flex-col sm:items-center lg:items-stretch`;
const Heading = tw.h1`text-3xl sm:text-5xl md:text-6xl lg:text-5xl font-black leading-none`;
const Paragraph = tw.p`max-w-md my-8 lg:my-5 lg:my-8 sm:text-lg lg:text-base xl:text-lg leading-loose`;

const Actions = styled.div`
  ${tw`mb-8 lg:mb-0`}
  .action {
    ${tw`text-center inline-block w-full sm:w-48 py-4 font-semibold tracking-wide rounded hocus:outline-none focus:shadow-outline transition duration-300`}
  }
  .primaryAction {
    ${tw`bg-primary-500 text-gray-100 hover:bg-primary-700`}
  }
  .secondaryAction {
    ${tw`mt-4 sm:mt-0 sm:ml-4 bg-gray-300 text-gray-700 hover:bg-gray-400 hover:text-gray-800`}
  }`;

export default ({
  navLinks = [
    <NavLinks key={1}>
      <NavLinkScroll to="escritorios" spy={true} smooth={true} offset={-70} duration={500}>Escritórios</NavLinkScroll>
      <NavLink href="https://www.gecond.com/login">Meu Condomínio</NavLink>
      <NavLinkScroll to="servicos" spy={true} smooth={true} offset={-70} duration={500}>Serviços</NavLinkScroll>
      <NavLinkScroll to="sobre" spy={true} smooth={true} offset={-70} duration={500}>Sobre</NavLinkScroll>
    </NavLinks>
  ],
  heading = (
    <>
      Condomínios geridos
      <wbr />
      <br />
      <span tw="text-primary-500">com excelência.</span>
    </>
  ),
  description = "Operamos nas seguintes zonas: Santa Comba Dão, Carregal do Sal, Mortágua, Nelas, Canas de Senhorim, Arganil, Viseu, Oliveira do Hospital, Tondela e Tábua. (Estamos em constante expansão)",
  primaryActionUrl = "contacto",
  primaryActionText = "Orçamentos",
  secondaryActionUrl = "escritorios",
  secondaryActionText = "Escritórios"
}) => {
  return (
    <Container>
      <TwoColumn>
        <LeftColumn>
          <StyledHeader links={navLinks} collapseBreakpointClass="sm" />
          <Content>
            <Heading>{heading}</Heading>
            <Paragraph>{description}</Paragraph>
            <Actions>
              <LinkPointer to={primaryActionUrl} className="action primaryAction" spy={true} smooth={true} offset={-70} duration={500}>{primaryActionText}</LinkPointer>
              <LinkPointer to={secondaryActionUrl} className="action secondaryAction" spy={true} smooth={true} offset={-70} duration={500}>{secondaryActionText}</LinkPointer>
            </Actions>
          </Content>
        </LeftColumn>
        <RightColumn></RightColumn>
      </TwoColumn>
    </Container>
  );
};
